import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ToastNotificationService } from 'src/app/services/toast-notification/toast-notification.service';
import * as dayjs from 'dayjs';
import { SlideDirections } from 'src/app/services/rest-api/rest-api';

@Component({
  selector: 'libero-documents-date-picker',
  templateUrl: './documents-date-picker.component.html',
  styleUrls: ['./documents-date-picker.component.scss'],
  standalone: false
})
export class DocumentsDatePickerComponent {
  @Input() public fromControl!: AbstractControl;
  @Input() public toControl!: AbstractControl;

  public slideDirections = SlideDirections;

  public constructor(
    public toastService: ToastNotificationService,
  ) { }

  public arrowDisabled(direction: 'from' | 'to', monthDirection: SlideDirections): boolean {
    const monthDifference = Math.abs(dayjs(this.toControl.value).month() - dayjs(this.fromControl.value).month());
    const yearDifference = Math.abs(dayjs(this.toControl.value).year() - dayjs(this.fromControl.value).year());

    if(yearDifference > 0) {
      return false
    }

    if(direction === 'from') {
      if(monthDirection === SlideDirections.NEXT) {
        return monthDifference === 0;
      }
    }
    if(direction === 'to') {
      if(monthDirection === SlideDirections.PREV) {
        return monthDifference === 0
      }
    }

    return false;
  }

  public prevMonth(direction: 'from' | 'to'): void {
    if(direction === 'from') {
      const updatedValue = dayjs(this.fromControl.value).add(-1, 'month').startOf('month');
      this.fromControl.patchValue(updatedValue);
    }
    if(direction === 'to') {
      const updatedValue = dayjs(this.toControl.value).add(-1, 'month').endOf('month');
      this.toControl.patchValue(updatedValue);
    }
  }

  public nextMonth(direction: 'from' | 'to'): void {
    if(direction === 'from') {
      const updatedValue = dayjs(this.fromControl.value).add(1, 'month').startOf('month');
      this.fromControl.patchValue(updatedValue);
    }
    if(direction === 'to') {
      const updatedValue = dayjs(this.toControl.value).add(1, 'month').endOf('month');
      this.toControl.patchValue(updatedValue);
    }
  }
}
